<template>
  <span>
    <span style="text-align: left" v-if="campo.cmp_join_tipo == 'select'">
      <template v-if="modo == 'new' || modo == 'edit' || modo == 'flow'">
        <v-layout v-if="lockval == false" row style="margin-top: 0px">
          <v-flex pa-0 ma-0>
            <v-autocomplete
              :loading="loading"
              :items="itensSelectMostrar"
              item-text="v"
              item-value="k"
              v-bind:value="preLoad(value)"
              v-on:input="event => $emit('input', preUpdate(event))"
              required
              :rules="crud.evalrules(campo)"
              clearable
              :hint="T(campo.cmp_dica)"
              persistent-hint
              :search-input.sync="search"
              @keyup="searchUp"
              :placeholder="
                campo.cmp_join_lazy * 1 > 0 ? T('Digite para pesquisar') : ''
              "
              background-color="#fcfcfc"
              @change="alterouSelectRadio()"
            ></v-autocomplete>
          </v-flex>
          <v-flex pa-0 shrink v-if="getComponentParam('addmore') != null">
            <v-btn
              dark
              icon
              small
              color="primary lighten-2"
              class="mt-3"
              @click="displayDialog = true"
            >
              <v-icon>add</v-icon>
            </v-btn>

            <v-dialog v-if="displayDialog" v-model="displayDialog">
              <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                  {{ T(getComponentParam("titulo") || "Incluir indicador") }}
                </v-card-title>

                <v-card-text>
                  <crud-tag
                    :embedprops="{
                      params: {
                        module: getComponentParam('tabela') || 'indicador',
                        action: 'new'
                      },
                      props: {
                        filtro: false,
                        gc: false,
                        rodape: true,
                        paginacao: false,
                        titulo: false,
                        select: false,
                        exportserver: false
                      }
                    }"
                    :backfn="() => addnewBack()"
                    :returnfn="data => addnewSave(data)"
                  />
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>

        <div class="pt-4" v-else>{{ lockval.v }}</div>
      </template>

      <template v-if="modo == 'list' || modo == 'view' || modo == 'viewmode'">
        <span :class="{ 'text-xs-left': crud.action == 'list' }">{{
          valoramostrar
        }}</span>
      </template>

      <template v-if="modo == 'filtro'">
        <v-autocomplete
          :loading="loading"
          :items="itensSelectMostrar"
          item-text="v"
          item-value="k"
          clearable
          class="ma-0 pa-1"
          height="20"
          hide-details
          v-bind:value="preLoad(value)"
          v-on:keyup.enter="onEnter"
          v-on:input="event => $emit('input', preUpdate(event))"
          @change="alterouSelectRadio()"
          :search-input.sync="search"
          @keyup="searchUp"
          :placeholder="
            campo.cmp_join_lazy * 1 > 0 ? T('Digite para pesquisar') : ''
          "
          background-color="#fcfcfc"
        >
          <template slot="selection" slot-scope="{ item }">
            <span
              style="text-align: left; font-size: 12px;white-space: initial;"
            >
              {{ item.v }}
            </span>
          </template>
          <template slot="item" slot-scope="{ item }">
            <span
              style="text-align: left; font-size: 12px;white-space: initial;"
            >
              {{ item.v }}
            </span>
          </template>
        </v-autocomplete>
      </template>
    </span>

    <span style="text-align: left" v-if="campo.cmp_join_tipo == 'radio'">
      <template v-if="modo == 'new' || modo == 'edit' || modo == 'flow'">
        <v-radio-group
          row
          v-if="lockval == false"
          :mandatory="false"
          v-model="intravalue"
          required
          :rules="crud.evalrules(campo)"
          :hint="T(campo.cmp_dica)"
          persistent-hint
        >
          <v-radio
            v-for="n in itensSelectMostrar"
            :key="n.k"
            :label="n.v"
            :value="n.k"
          ></v-radio>
        </v-radio-group>

        <div class="pt-4" v-else>{{ lockval.v }}</div>
      </template>

      <template v-if="modo == 'list' || modo == 'view' || modo == 'viewmode'">
        <span :class="{ 'text-xs-left': crud.action == 'list' }">{{
          valoramostrar
        }}</span>
      </template>

      <template v-if="modo == 'filtro'">
        <v-autocomplete
          :items="itensSelectMostrar"
          item-text="v"
          item-value="k"
          clearable
          hide-details
          class="ma-0 pa-1"
          height="20"
          v-bind:value="preLoad(value)"
          v-on:keyup.enter="onEnter"
          v-on:input="event => $emit('input', preUpdate(event))"
          @change="alterouSelectRadio()"
          background-color="#fcfcfc"
          :search-input.sync="search"
          @keyup="searchUp"
          :placeholder="
            campo.cmp_join_lazy * 1 > 0 ? T('Digite para pesquisar') : ''
          "
        >
          <template slot="selection" slot-scope="{ item }">
            <span
              style="text-align: left; font-size: 12px;white-space: initial;"
            >
              {{ item.v }}
            </span>
          </template>
          <template slot="item" slot-scope="{ item }">
            <span
              style="text-align: left; font-size: 12px;white-space: initial;"
            >
              {{ item.v }}
            </span>
          </template>
        </v-autocomplete>
      </template>
    </span>

    <!--NxN-->
    <span style="text-align: left" v-if="campo.cmp_join_tipo == 'NxN'">
      <template v-if="modo == 'new' || modo == 'edit' || modo == 'flow'">
        <v-layout row style="margin-top: 0px">
          <v-flex pa-0 ma-0>
            <v-autocomplete
              :items="itensSelectMostrar"
              item-text="v"
              item-value="k"
              v-model="multiples"
              required
              clearable
              :rules="crud.evalrules(campo)"
              multiple
              :hint="T(campo.cmp_dica)"
              persistent-hint
              background-color="#fcfcfc"
            >
              <div slot="prepend-item" class="text-xs-center">
                <a href="javascript:;" @click="selecionarTudo()">
                  <span
                    v-if="
                      multiples &&
                        itensSelectMostrar &&
                        multiples.length == itensSelectMostrar.length
                    "
                  >
                    <v-icon small>check_box</v-icon>
                    {{ T("Desmarcar todos") }}
                  </span>
                  <span v-else>
                    <v-icon small>check_box_outline_blank</v-icon>
                    {{ T("Marcar todos") }}
                  </span>
                </a>
              </div>
            </v-autocomplete>
          </v-flex>
          <v-flex pa-0 shrink v-if="getComponentParam('addmore') != null">
            <v-btn
              dark
              icon
              small
              color="indigo lighten-2"
              class="mt-3"
              @click="displayDialog = true"
            >
              <v-icon>add</v-icon>
            </v-btn>

            <v-dialog v-if="displayDialog" v-model="displayDialog">
              <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                  {{ T(getComponentParam("titulo") || "Incluir indicador") }}
                </v-card-title>

                <v-card-text>
                  <crud-tag
                    :embedprops="{
                      params: {
                        module: getComponentParam('tabela') || 'indicador',
                        action: 'new'
                      },
                      props: {
                        filtro: false,
                        gc: false,
                        rodape: true,
                        paginacao: false,
                        titulo: false,
                        select: false,
                        exportserver: false
                      }
                    }"
                    :backfn="() => addnewBack()"
                    :returnfn="data => addnewSave(data)"
                  />
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>
      </template>

      <template v-if="modo == 'list' || modo == 'view' || modo == 'viewmode'">
        <div
          :class="{ 'text-xs-left': modo == 'list' }"
          style="font-size: 10px; min-width: 120px"
        >
          {{ valoramostrar }}
        </div>
      </template>

      <template v-if="modo == 'filtro'">
        <v-autocomplete
          :items="itensSelectMostrar"
          item-text="v"
          clearable
          item-value="k"
          hide-details
          class="ma-0 pa-1"
          height="20"
          v-bind:value="preLoad(value)"
          v-on:keyup.enter="onEnter"
          v-on:input="event => $emit('input', preUpdate(event))"
          background-color="#fcfcfc"
        >
          <template slot="selection" slot-scope="{ item }">
            <span
              style="text-align: left; font-size: 12px;white-space: initial;"
            >
              {{ item.v }}
            </span>
          </template>
          <template slot="item" slot-scope="{ item }">
            <span
              style="text-align: left; font-size: 12px;white-space: initial;"
            >
              {{ item.v }}
            </span>
          </template>
        </v-autocomplete>
      </template>
    </span>

    <span style="text-align: left" v-if="campo.cmp_join_tipo == 'NxN checkbox'">
      <template v-if="modo == 'new' || modo == 'edit' || modo == 'flow'">
        <v-checkbox
          class="left ma-2"
          v-for="(ck, cki) in items"
          :key="cki"
          :label="ck.v"
          :value="ck.k"
          v-model="multiples"
          required
          :rules="crud.evalrules(campo)"
        ></v-checkbox>
      </template>

      <template v-if="modo == 'list' || modo == 'view' || modo == 'viewmode'">
        <div
          :class="{ 'text-xs-left': crud.action == 'list' }"
          style="font-size: 10px; min-width: 120px"
        >
          {{ valoramostrar }}
        </div>
      </template>

      <template v-if="modo == 'filtro'">
        <v-autocomplete
          :items="itensSelectMostrar"
          item-text="v"
          item-value="k"
          clearable
          hide-details
          class="ma-0 pa-1"
          height="20"
          v-bind:value="preLoad(value)"
          v-on:keyup.enter="onEnter"
          v-on:input="event => $emit('input', preUpdate(event))"
          background-color="#fcfcfc"
        >
          <template slot="selection" slot-scope="{ item }">
            <span
              style="text-align: left; font-size: 12px;white-space: initial;"
            >
              {{ item.v }}
            </span>
          </template>
          <template slot="item" slot-scope="{ item }">
            <span
              style="text-align: left; font-size: 12px;white-space: initial;"
            >
              {{ item.v }}
            </span>
          </template>
        </v-autocomplete>
      </template>
    </span>
  </span>
</template>

<script>
const Api = global.Api;
try {
  var bus = require("@/admin/elements/inc/bus").default;
} catch (err) {
  var bus = require("@/framework/admin/elements/inc/bus").default;
}

try {
  var _baseComponent = require("@/lib/componente/_base.vue").default;
} catch (err) {
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}
export default {
  extends: _baseComponent,
  data() {
    return {
      search: "",
      searchTimer: null,
      loading: false,
      lockval: false,
      intravalue: this.preLoad(this.value),
      multiples: this.preLoad(this.value),
      items: (() => {
        //return [];

        if (this.row._extra) {
          let array = this.row._extra[this.campo.cmp_coluna];
          return array;
        }
        if (this.crud.metadataextra) {
          let array = this.crud.metadataextra[this.campo.cmp_coluna];
          return array;
        }
      })(),
      displayDialog: false
    };
  },
  created() {
    bus.$off(
      "crud_" +
        this.crud.sid +
        "_" +
        this.campo.cmp_coluna +
        "_refresh" +
        this.modo
    );
    bus.$on(
      "crud_" +
        this.crud.sid +
        "_" +
        this.campo.cmp_coluna +
        "_refresh" +
        this.modo,
      () => {
        this.fazAsync();
      }
    );
  },
  destroy() {
    bus.$off(
      "crud_" +
        this.crud.sid +
        "_" +
        this.campo.cmp_coluna +
        "_refresh" +
        this.modo
    );
  },

  computed: {
    valoramostrar() {
      if (this.value == null) return "";

      if (
        this.campo.cmp_tipo == "join" &&
        this.campo.cmp_join_tipo.substr(0, 3) == "NxN"
      )
        return this.value;

      let tabela = this.crud.module;
      if (tabela.indexOf("_v_") != -1) tabela = tabela.split("_v_")[0];

      if (
        this.row[
          "_join_" +
            this.campo.cmp_coluna +
            "_" +
            tabela +
            "_" +
            this.campo.cmp_join_tabela
        ] == null
      )
        return "";

      return this.row[
        "_join_" +
          this.campo.cmp_coluna +
          "_" +
          tabela +
          "_" +
          this.campo.cmp_join_tabela
      ]._joined;
    },
    itensSelectMostrar() {
      return this._itensSelectMostrar();
    },

    addmoreNN() {
      let info = this.getComponentParam("addmore");
    }
  },
  mounted() {
    if (this.crud.localsession != null) {
      let locases = this.crud.localsession[this.crud.sid];
      if (
        this.modo != "filtro" &&
        locases.joined != null &&
        locases.joined == this.campo.cmp_coluna &&
        this.row != null &&
        this.row._extra != null &&
        this.row._extra[this.campo.cmp_coluna] != null
      ) {
        if (locases.joinedid < 0) {
          //this.value = locases.joinedid;
          this.$emit("input", locases.joinedid);
          this.crud.form[this.campo.cmp_coluna] = locases.joinedid;
          this.lockval = { k: locases.joinedid, v: "Módulo atual" };
        } else {
          //this.value = locases.joinedid;
          setTimeout(() => {
            this.$emit("input", locases.joinedid);
          }, 100);

          this.crud.form[this.campo.cmp_coluna] = locases.joinedid;

          this.lockval = this.row._extra[this.campo.cmp_coluna].filter(
            v => v.k == locases.joinedid
          );
          this.lockval =
            this.lockval != null && this.lockval.length > 0
              ? this.lockval[0]
              : false;
          this.$forceUpdate();
        }
      }
    }

    if (this.crud.action == "new" && !this.crud.actionid)
      this.alterouSelectRadio();
  },

  methods: {
    _itensSelectMostrar() {
      if (this.crud.localsession != null) {
        let locases = this.crud.localsession[this.crud.sid];
        if (
          this.modo != "filtro" &&
          locases.joined != null &&
          locases.joined == this.campo.cmp_coluna
        ) {
          if (this.row._extra) {
            let array = this.row._extra[this.campo.cmp_coluna].filter(
              v => v.k == locases.joinedid
            );
            return array;
          }
        }
      }

      if (this.row._extra) {
        let array = this.row._extra[this.campo.cmp_coluna];
        return array;
      }
      if (this.crud.metadataextra) {
        let array = this.crud.metadataextra[this.campo.cmp_coluna];
        return array;
      }
      return [];
    },

    selecionarTudo() {
      let all = this._itensSelectMostrar();
      //console.log('clici', all, this.multiples)
      if (all == null || !this.multiples) return;
      if (this.multiples.length < all.length)
        this.multiples = all.map(v => v.k);
      else this.multiples = [];
    },
    preLoad(myval) {
      if (this.campo.cmp_join_tipo == "select" || this.modo == "filtro") {
        if (myval == undefined) return null;
        return myval;
      }
      if (this.campo.cmp_join_tipo == "radio") {
        if (myval == undefined) return null;
        return myval;
      }
      if (this.campo.cmp_join_tipo.substr(0, 3) == "NxN") {
        if (myval == undefined || myval == null) return [];
        return myval;
      }
    },
    preUpdate(myval) {
      return myval;
    },
    alterouSelectRadio() {
      let params = this.getComponentParam("updates");
      if (params != null && params != "") {
        params
          .split(",")
          .map(v => v.trim())
          .forEach(alvo => {
            bus.$emit(
              "crud_" + this.crud.sid + "_" + alvo + "_refresh" + this.modo
            );
          });
      }
    },
    fazAsync(query = null) {
      this.loading = true;

      let clone = _.clone(this.crud.localsession[this.crud.sid]);
      delete clone["filtro"];

      if (this.modo != "filtro")
        clone.master = _.pickBy(
          this.crud.form,
          (v, k) => !_.startsWith(k, "_")
        );
      else {
        clone.master = _.clone(this.crud.localsession[this.crud.sid].filtro);
      }

      let credentials = {
        module: this.crud.module,
        localsession: clone,
        column: this.campo.cmp_coluna,
        action: "actionComponentUpdate"
      };

      if (query != null) credentials.query = query;
      Api()
        .post("admin/crud/async", credentials)
        .then(result => {
          if (result.data.output !== null) {
            if (this.modo != "filtro") {
              this.row._extra[this.campo.cmp_coluna] = result.data.output;
              this.items = this.row._extra[this.campo.cmp_coluna];
              this.crud.form[this.campo.cmp_coluna] = null;
              if (this.campo.cmp_join_tipo.substr(0, 3) == "NxN")
                this.multiples = [];
            } else {
              this.crud.metadataextra[this.campo.cmp_coluna] =
                result.data.output;
              this.items = this.crud.metadataextra[this.campo.cmp_coluna];
              this.crud.localsession[this.crud.sid].filtro[
                this.campo.cmp_coluna
              ] = null;
            }

            if (query != null && query == "*") {
              this.search = "";
            }
            this.alterouSelectRadio();
          }

          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
    },
    addnewBack() {
      this.displayDialog = false;
    },
    addnewSave(data) {
      console.log("RETON", data);

      if (!data.obj) {
        data.obj = data;
      }

      this.row._extra[this.campo.cmp_coluna].push({
        k: data.obj.id,
        v: data.obj[this.campo.cmp_join_mostra]
      });
      if (this.campo.cmp_join_tipo.substr(0, 3) == "NxN")
        this.multiples.push(data.obj.id);
      else {
        this.value = data.obj.id;
        this.$emit("input", this.preUpdate(this.value));
      }

      this.displayDialog = false;
    },

    searchUp() {
      let val = this.search;
      if (this.campo.cmp_join_lazy * 1 == 0) return;
      val && val != this.value && this.querySelections(val.trim());
    },

    querySelections(v) {
      // Simulated ajax query

      if (this.searchTimer != null) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }

      this.searchTimer = setTimeout(() => {
        this.searchTimer = null;

        console.log("pesquisou por ", v, this.value);
        this.fazAsync(v);
      }, 500);

      /*setTimeout(() => {
        this.items = this.states.filter(e => {
          return (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
        });
        this.loading = false;
      }, 500);*/
    }
  },
  watch: {
    intravalue(val) {
      this.$emit("input", this.preUpdate(val));
      if (this.campo.cmp_join_tipo == "radio") {
        setTimeout(() => this.alterouSelectRadio(), 500);
      }
    },
    multiples(val) {
      this.$emit("input", this.preUpdate(val));
    },
    value(v) {
      this.multiples = this.preLoad(this.value);
    }
  }
};
</script>

<style scoped></style>
